
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signin",
      function () {
        return require("private-next-pages/auth/signin/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/signin"])
      });
    }
  